<template>
  <div class="from_area">
    <div class="container">

      <div class="row">

        <div class="txt col col-12 col-sm-6">
          <formtxt></formtxt>
        </div>

        <div class="input col col-12 col-sm-6">
          <Form></Form>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Form from '@/components/only_form.vue';
import formtxt from '@/components/form_text.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    Form,
    formtxt,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.from_area{
  padding: 50px 0;
  background-color: rgb(255, 245, 232);
  .row{
    margin: auto;
    .txt{
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 15px;
    }
    .input{
      width: 50%;
      margin: 20px 0;
    }
  }
}
@media screen and (max-width: 600px){
  .from_area .row{
    .txt{
      padding: 0;
      align-items: flex-start;
    }
    .input{
      padding: 0;
    }
  }
}
</style>
